export const toggleSelectedId = (
  previous: number[],
  targetId: number,
  isChecked: boolean
): number[] => {
  if (isChecked) {
    return previous.includes(targetId) ? previous : [...previous, targetId];
  }

  return previous.filter((id) => id !== targetId);
};

export const clearSelectedIds = (): number[] => [];
